module.exports = __webpack_public_path__ + "img/logintitle.050c0790.png";